import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-executive-rooms',
  templateUrl: './executive-rooms.component.html',
  styleUrls: ['./executive-rooms.component.css']
})
export class ExecutiveRoomsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.GetWhatsappNos();
  }

  WhatsappList:any[]=[];
  GetWhatsappNos()
  {
    let nos =  (<HTMLInputElement>document.getElementById("hdnWhatsapp")).value;
    this.WhatsappList = nos.split(",");
  }
}
